import { FlexStrip } from "@components/home/FlexStrip";
import { Page } from "@components/layout/Page";
import { FormBlock, TextBlock } from "@components/product/Blocks";
import { ProductHero } from "@components/product/ProductHero";
import { Steps } from "@components/shared/Steps";
import { UNLOCK } from "@/lib/site";
import { useTranslations } from "@services/strings";
import Link from "next/link";

const PayLessPage = () => {
  const { t } = useTranslations();
  const vars = { maxYears: UNLOCK.maxYears };

  const rows = (["payee", "term", "monthly", "documents"] as const).map(
    (id) => ({
      id,
      label: t(`site.payLess.compare.rows.${id}.label`),
      today: t(`site.payLess.compare.rows.${id}.today`),
      after: t(`site.payLess.compare.rows.${id}.after`, vars),
    }),
  );

  return (
    <Page
      title={t("site.payLess.meta.title")}
      description={t("site.payLess.meta.description", vars)}
    >
      <ProductHero
        placement="pay-less-hero"
        eyebrow={t("site.payLess.hero.eyebrow")}
        title={t("site.payLess.hero.title")}
        subtitle={t("site.payLess.hero.subtitle", vars)}
        cta={
          <Link
            href="#contact-form"
            className="inline-flex h-12 items-center rounded-full bg-ink px-6 text-base font-semibold text-white hover:bg-navy"
          >
            {t("site.payLess.form.title")}
          </Link>
        }
        aside={
          <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-2 shadow-panel">
            <table className="w-full table-fixed text-start text-[15px]">
              <caption className="sr-only">
                {t("site.payLess.compare.title")}
              </caption>
              <thead>
                <tr className="text-sm text-slate-500">
                  <th
                    scope="col"
                    className="w-[36%] p-3 text-start font-medium"
                  />
                  <th scope="col" className="p-3 text-start font-medium">
                    {t("site.payLess.compare.today")}
                  </th>
                  <th
                    scope="col"
                    className="rounded-t-2xl bg-lavender p-3 text-start font-semibold text-lavender-ink"
                  >
                    {t("site.payLess.compare.withPayLess")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={row.id} className="border-t border-slate-100">
                    <th
                      scope="row"
                      className="p-3 text-start font-medium text-slate-600"
                    >
                      {row.label}
                    </th>
                    <td className="p-3 text-slate-700">{row.today}</td>
                    <td
                      className={`bg-lavender p-3 font-semibold text-ink ${
                        index === rows.length - 1 ? "rounded-b-2xl" : ""
                      }`}
                    >
                      {row.after}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      />

      <TextBlock
        tone="mist"
        title={t("site.payLess.status.title")}
        body={t("site.payLess.status.body")}
      />

      <Steps
        title={t("site.payLess.how.title")}
        steps={(["one", "two", "three"] as const).map((id) => ({
          title: t(`site.payLess.how.items.${id}.title`),
          body: t(`site.payLess.how.items.${id}.body`, vars),
        }))}
      />

      <FlexStrip
        placement="pay-less"
        title={t("site.home.flexStrip.title")}
        body={t("site.home.flexStrip.body")}
        cta={t("site.home.flexStrip.cta")}
      />

      <FormBlock
        title={t("site.payLess.form.title")}
        body={t("site.payLess.form.body")}
        interest="payLess"
        placement="pay-less"
      />
    </Page>
  );
};

export default PayLessPage;
